import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { appointmentService } from "../../services/appointment";

const initialState = {
  timeslot: [],
  loading: false,
  error: "",
};

export const timeslot = createAsyncThunk("timeslot", async (playload) => {
  const { data, status } = await appointmentService.Timeslot(playload);
  data.status = status;
  return data;
});

export const bookAppointment = createAsyncThunk("book_appointment", async (playload) => {
  const { data, status } = await appointmentService.BookAppointment(playload);
  data.status = status;
  return data;
});

export const createRazorpayAppointmentOrder = createAsyncThunk("razorpay_create_appointment_order", async (payload, { rejectWithValue }) => {
  const response = await appointmentService.CreateRazorpayAppointmentOrder(payload);
  if (!response || !response.data) {
    return rejectWithValue({ msg: 'Failed to initialize payment. Please try again.' });
  }
  if (response.status >= 400) {
    return rejectWithValue(response.data);
  }
  const { data, status } = response;
  data.status = status;
  return data;
});

export const verifyRazorpayAppointmentPayment = createAsyncThunk("razorpay_verify_appointment_payment", async (payload) => {
  const { data, status } = await appointmentService.VerifyRazorpayAppointmentPayment(payload);
  data.status = status;
  return data;
});

export const checkGuestDiscount = createAsyncThunk("check_guest_discount", async (phone) => {
  const response = await appointmentService.CheckGuestDiscount(phone);
  if (response && response.data) {
    return response.data;
  }
  return { has_discount: false, discount_amount: 0 };
});

export const appointments = createAsyncThunk("appointments", async (playload) => {
  const { data, status } = await appointmentService.Appointments(playload);
  data.status = status;
  return data;
});

export const transactionHistory = createAsyncThunk("transaction_history", async (playload) => {
  const { data, status } = await appointmentService.TransactionHistory(playload);
  data.status = status;
  return data;
});

export const appointmentDetail = createAsyncThunk("appointment_detail", async (payload) => {
  const { data, status } = await appointmentService.AppointmentDetail(payload);
  data.status = status;
  return data;
});

export const cancelAppointment = createAsyncThunk("cancel_appointment", async (payload) => {
  const { data, status } = await appointmentService.CancelAppointment(payload);
  data.status = status;
  return data;
});

export const getPage = createAsyncThunk("get_page", async (payload) => {
  const { data, status } = await appointmentService.GetPage(payload);
  data.status = status;
  return data;
});

export const downloadInvoice = createAsyncThunk("download_invoice", async (payload) => {
  const { data, status } = await appointmentService.DownloadInvoice(payload);
  data.status = status;
  return data;
});

export const getInvoiceUrl = createAsyncThunk("get_invoice_url", async (payload) => {
  const { data, status } = await appointmentService.GetInvoiceUrl(payload);
  data.status = status;
  return data;
});

// Update appointment (for rescheduling)
export const updateAppointment = createAsyncThunk("update_appointment", async (payload) => {
  const { data, status } = await appointmentService.UpdateAppointment(payload);
  data.status = status;
  return data;
});


const AppoinmentSlice = createSlice({
  name: "authUser",
  initialState,
  reducers: {
    logoutAppoinment: (state) => {
      state.token = null;
      localStorage.clear();
      state.timeslot = [];
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(timeslot.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(timeslot.fulfilled, (state, { payload }) => {
        state.loading = false;
        if (payload.success) {
          state.token = payload.data.token;
          localStorage.setItem("userAccess", `Bearer ${payload.data.token}`);
        }
      })
      .addCase(timeslot.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });

  }
});

export const { logoutAppoinmen } = AppoinmentSlice.actions;
export default AppoinmentSlice.reducer;
